/* TradersMat — interactions v3 · native cursor, quiet animations */
(() => {
  "use strict";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$("[data-reveal]");
  if (reveals.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(entries => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      }
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.06 });
    reveals.forEach(el => io.observe(el));
  }

  /* ---------- Nav: scroll shadow + mobile menu ---------- */
  const nav = $("#nav");
  if (nav) {
    const onScroll = () => {
      nav.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    addEventListener("scroll", onScroll, { passive: true });
  }

  const burger = $("#burger");
  if (burger && nav) {
    burger.addEventListener("click", () => {
      const open = nav.classList.toggle("is-menu-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    $$(".nav__links a").forEach(a => a.addEventListener("click", () => {
      nav.classList.remove("is-menu-open");
      burger.setAttribute("aria-expanded", "false");
    }));
  }

  /* ---------- Smooth scroll for hash links ---------- */
  $$("a[href^='#']").forEach(a => {
    a.addEventListener("click", e => {
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }
    });
  });

  /* ---------- PDP: thumb gallery ---------- */
  const pdpMain = $(".pdp__main img");
  const pdpThumbs = $$(".pdp__thumbs button");
  if (pdpMain && pdpThumbs.length) {
    pdpThumbs.forEach(btn => {
      btn.addEventListener("click", () => {
        pdpThumbs.forEach(b => b.setAttribute("aria-selected", "false"));
        btn.setAttribute("aria-selected", "true");
        const src = btn.dataset.src;
        if (src) pdpMain.src = src;
      });
    });
  }

  /* ---------- Qty stepper ---------- */
  $$(".qty").forEach(group => {
    const input = group.querySelector("input");
    const minus = group.querySelector("[data-qty='-']");
    const plus = group.querySelector("[data-qty='+']");
    if (!input) return;
    const step = (delta) => {
      const v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + delta);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };
    if (minus) minus.addEventListener("click", () => step(-1));
    if (plus) plus.addEventListener("click", () => step(1));
  });
})();

/* ---------- Shopify cart badge refresh ---------- */
(function(){
  function updateBadge(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  window.addEventListener('pageshow', function(){
    if(!window.fetch) return;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ updateBadge(c.item_count); })
      .catch(function(){});
  });

  var pdpForm = document.getElementById('pdpForm');
  if(pdpForm){
    pdpForm.addEventListener('submit', function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var btn = pdpForm.querySelector('[data-atc-btn]');
      var lbl = pdpForm.querySelector('[data-atc-label]');
      var orig = lbl ? lbl.textContent : '';
      if(lbl) lbl.textContent = 'Adding…';
      if(btn) btn.disabled = true;
      var fd = new FormData(pdpForm);
      fetch('/cart/add.js', {method:'POST', body: fd, headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
        })
        .then(function(c){
          updateBadge(c.item_count);
          if(lbl) lbl.textContent = 'Added ✓';
          setTimeout(function(){ if(lbl) lbl.textContent = orig || 'Add to bag'; if(btn) btn.disabled = false; }, 1400);
        })
        .catch(function(){
          pdpForm.submit();
        });
    });
  }
})();
